module.exports = __webpack_public_path__ + "img/cn.02c229de.svg";